//@flow
import React from 'react';
import {Container} from 'flux/utils';
import { withRouter } from 'react-router';
import MktgStore from '../js/Stores/Mktg/mktgStore';
import CustomerStore from '../js/Stores/Customer/customer';
import MktgActions from '../js/Actions/mktg';
import Ire from '../js/Utils/ire-interface';
import UrlData from '../js/Utils/url-data';

import type CustomerModel from '../js/Stores/Customer/customerModel';
import type { ContextRouter } from 'react-router';

type State = {
  // TODO: add type annotation
  mktgData:any,
  customer:CustomerModel,
};

type Props = ContextRouter;

class MktgListener extends React.Component<Props, State> {
  static getStores() {
    return [
      MktgStore,
      CustomerStore,
    ];
  }

  static calculateState():State {
    return {
      mktgData: MktgStore.getMktgData(),
      customer: CustomerStore.getCustomer(),
    };
  }

  componentDidMount() {
    // Fetch mktg data if it's not already loaded
    // or if special parameter to force load is
    // specified
    const mktgDataPreview = UrlData.getMktgDataPreview() === 'true';
    if (!this.state.mktgData || mktgDataPreview) {
      MktgActions.fetchMktgData();
    }
    // Per IRE / DMS requirements, we need to call
    // `identify` even when there is no customer data
    // loaded.  When customer is available (e.g. after
    // successful request to fetch customer), `identify`
    // will also be called in heapStoreClass
    const {customer} = this.state;
    const customerId = customer ? customer.getId() : '';
    const customerEmail = customer ? customer.getEmail() : '';
    Ire.identify(customerId, customerEmail);
  }

  render() {
    return null;
  }
}

export default withRouter(Container.create(MktgListener));
